<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import './assets/styles/index.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue